import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useMe } from "@/components/app/MeContext";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg } from "@/lib/api";

// Admin setting: who finance alerts (over-invoiced LM short close) go to
export function FinanceEmailsPanel() {
  const { can } = useMe();
  const { data } = useFetch("/settings/finance-emails");
  const [v, setV] = useState("");
  useEffect(() => { if (data) { setV(data.emails); } }, [data]);
  if (!data) return null;
  const save = async () => { try { const r = await api.put("/settings/finance-emails", { emails: v }); setV(r.data.emails); toast.success("Finance notification emails saved"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="mb-6 rounded border border-slate-200 bg-white p-4" data-testid="finance-emails-panel">
      <h3 className="text-sm font-semibold">Finance notification emails</h3>
      <p className="text-xs text-slate-500 mb-2">Comma-separated. They are emailed when an over-invoiced LM is sent for short close.{data.mail_configured ? "" : " Email sending is not set up - finance alerts appear only as LM remarks."}</p>
      <div className="flex flex-wrap gap-2">
        <Input className="sm:max-w-lg" value={v} onChange={(e) => setV(e.target.value)} placeholder="finance@company.com, accounts@company.com" disabled={!can("admin.settings")} data-testid="finance-emails-input" />
        {can("admin.settings") && <Button size="sm" onClick={save} data-testid="finance-emails-save">Save</Button>}
      </div>
    </div>
  );
}
